import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { bindAll } from '@bibliocommons/utils-react';
import { catalogBibShape, libraryShape, listShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectStaffListsForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { trackContentClick } from 'app/actions/AnalyticsGa4Actions';

import StaffLists from './StaffLists';

export class StaffListsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleListTitleClick(listId, listTitle) {
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'staff-lists-featuring-this-title',
      ui_component_type: 'link-text',
      ui_component_label: listTitle
    };
    this.props.trackContentClick({ listId, ui });
  }

  handleListImageClick(listId) {
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'staff-lists-featuring-this-title',
      ui_component_type: 'link-image'
    };
    this.props.trackContentClick({ listId, ui });
  }

  render() {
    return (
      <StaffLists
        {...this.props}
        handleListTitleClick={this.handleListTitleClick}
        handleListImageClick={this.handleListImageClick}
      />
    );
  }
}

StaffListsContainer.propTypes = {
  catalogBib: catalogBibShape,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  lists: ImmutablePropTypes.listOf(listShape).isRequired,
  library: libraryShape,
  trackContentClick: PropTypes.func
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  users: selectUserEntities(state),
  lists: selectStaffListsForCurrentBib(state),
  library: selectCurrentLibrary(state)
});

const mapDispatchToProps = dispatch => ({
  trackContentClick: bindActionCreators(trackContentClick, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(StaffListsContainer);
